<!--
 * @Author: zhubincong
 * @Date: 2020-3-9 19:41:31
 * @Desc: 区域圆弧图
 -->
<template>
  <div class="region-cycle">
    <p class="region-rate">{{ region.rate }}%</p>
    <p class="region-name">{{ region.regionName }}</p>
    <div ref="chart" class="chart"></div>
  </div>
</template>

<script>
import G2 from '@antv/g2'
export default {
  name: 'RegionCycleChart',
  props: {
    region: {
      type: Object,
      required: true
    },

    // 屏幕尺寸类型
    sizeMode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 图表尺寸
      chartSize: {
        sm: {
          height: 71,
          width: 71
        },
        md: {
          height: 85,
          width: 85
        },
        lg: {
          height: 100,
          width: 100
        }
      },
      chart: null
    }
  },
  watch: {
    sizeMode(data) {
      this.changeChartSize()
    }
  },
  mounted() {
    this.chart = null
    if (this.region.rate) {
      this.renderChart()
    }
  },
  methods: {
    /**
     * 渲染环图
     * @author zhubincong
     * @date 2020-03-20 10:24:23
     */
    renderChart() {
      const chartData = [
        { rate: this.region.rate, name: '占比' },
        { rate: 100 - this.region.rate, name: '其他' }
      ]
      const { width, height } = this.chartSize[this.sizeMode]

      const chart = new G2.Chart({
        container: this.$refs.chart,
        // forceFit: true,
        width,
        height,
        padding: 'auto'
      })
      this.chart = chart
      // 数据
      chart.source(chartData)
      // 坐标系
      chart.coord('theta', {
        radius: 0.95,
        innerRadius: 0.8
      })
      // 不显示图例自己绘制
      chart.legend(false)
      // 不显示tooltip
      chart.tooltip(false)
      // 几何标记
      chart
        .intervalStack()
        .position('rate')
        .color('name', ['l(0) 0:#00FFED 1:#CFFFFE', '#0000'])
        .size(8)
        .shape('dashPath')
        .style({
          shadowColor: '#145166',
          shadowOffsetY: 5,
          shadowBlur: 5,
          fillOpacity: 0.95
        })
        .select(false)
        .active(false)
      chart.render()
    },

    /**
     * @author xuchen
     * @date 2020-04-26 19:46:58
     * @desc 修改环形图大小
     */
    changeChartSize() {
      if (this.chart) {
        const { width, height } = this.chartSize[this.sizeMode]
        this.chart.changeSize(width, height)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.region-cycle {
  position: relative;
  flex: 0 0 auto;
  text-align: center;
  background: url('~@/assets/images/RiskMonitoring/region.png') no-repeat;
  background-size: cover;
  background-position: center;
}
.region-rate {
  color: #ffffff;
}
.region-name {
  color: #8feeff;
}
.chart {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>

<style lang="scss" scoped>
@media screen and (min-width: 1900px) {
  .region-cycle {
    width: 110px;
    height: 114px;
  }
  .region-rate {
    padding: 23px 0 6px;
    font-size: 22px;
  }
  .region-name {
    font-size: 14px;
  }
}

@media screen and (min-width: 1600px) and (max-width: 1899px) {
  .region-cycle {
    width: 89px;
    height: 102px;
    background-position: center -2px;
  }
  .region-rate {
    padding: 25px 0 3px;
    font-size: 16px;
  }
  .region-name {
    font-size: 12px;
  }
}

@media screen and (max-width: 1599px) {
  .region-cycle {
    width: 70px;
    height: 83px;
    background-position: center -1px;
  }
  .region-rate {
    padding: 19px 0 3px;
    font-size: 14px;
  }
  .region-name {
    font-size: 10px;
  }
}
</style>
